import { freeDescriptorCode } from 'constants/free';
import { t } from '@lingui/macro';
import { BaseMeta } from 'types';

export const getMetasDisplayName = (
    metas: BaseMeta[],
    isFree = false,
): string[] => {
    const cleanedMetas = [
        ...new Set<string>(
            [...metas]
                .filter((tag) => tag && 'code' in tag)
                .map(({ code }: BaseMeta<string>) => code),
        ),
    ];

    // Remove 'free' from metas
    const extendedMetas = cleanedMetas.filter(
        (code) => code !== freeDescriptorCode,
    );

    // Add 'free' last
    if (isFree) {
        extendedMetas.push(freeDescriptorCode);
    }

    const metasDisplayName = extendedMetas.map((code) => t({ id: code }));

    return metasDisplayName;
};
